<script setup lang="ts">
import type { Paragraph } from '~/utils/crystallize/component-schemas'

defineProps<{ data: Paragraph }>()
</script>

<template>
  <div class="gap-m" :class="data.images ? 'grid grid-cols-subgrid' : 'flex flex-col'">
    <h2 v-if="data.title?.text" class="title-m col-span-full" v-text="data.title.text" />

    <CrystallizeRichText
      v-for="(block, i) in data.body?.json" :key="i" :block="block"
      data-paragraph
      :class="data.images ? 'col-span-4 md:col-span-2 lg:col-span-3 2xl:col-span-4' : 'col-span-full'"
    />

    <div v-if="data.images?.images" class="col-span-4 md:col-span-2 2xl:col-span-3">
      <CrystallizeImage
        v-for="image in data.images?.images"
        :key="image.url"
        :image="image"
        class="text-carbon-400 text-base flex flex-col gap-s"
        img-class="rounded-2xl"
      >
        <template #meta="{ meta }">
          <span v-if="meta.copyright" class="text-xs text-carbon-300">
            © {{ meta.copyright }}
          </span>
        </template>
      </CrystallizeImage>
    </div>
  </div>
</template>

<style scoped>
ul[data-paragraph],
ol[data-paragraph] {
  @apply list-disc flex flex-col gap-m;
}
</style>
